<template>
	<div class="height-100dvh">
		<div class="mob-back-header d-flex align-items-center">
			<img
				@click="$router.go(-1)"
				class="mr-3"
				src="../../assets/mobile/assprog/mobileBackArrow.svg"
				alt=""
			/>
			Job Prefrerences
		</div>
		<div class="mob-back-body">
			<div class="mobjd-applied-top">
				<div class="mobjd-jobdetails h-100">
					<b-row class="">
						<b-col class="floating-label">
							<div class="position-relative pt-1">
								<InputField
									:id="'totalYearsOfExp'"
									:label="'Current CTC'"
									:type="'text'"
									:mandatory="false"
									:vmodel="formData.currentCTC"
									:placeholder="'Enter'"
									@select-value="updateCurrentCTC"
								/>
							</div>
						</b-col>
					</b-row>
					<b-row class="mt-3">
						<b-col>
							<div class="position-relative pt-1">
								<InputField
									:id="'totalYearsOfExp'"
									:label="'Expected CTC'"
									:type="'text'"
									:mandatory="false"
									:vmodel="formData.expectedCTC"
									:placeholder="'Enter'"
									@select-value="updateExpectedCTC"
								/>
							</div>
						</b-col>
					</b-row>
					<b-row class="mt-3">
						<b-col>
							<div class="position-relative pt-1">
								<FormTags
									type="text"
									placeholder="Enter"
									id="123"
									fileFormat="text"
									:suggestions="[]"
									@select-value="updateLocation"
									maxFileSize="5000"
									:vmodel="formData.willingToRelocateTo"
									:v-model="formData.preferredLocations"
									:label="'Preferred Locations'"
								/>
							</div>
						</b-col>
					</b-row>
					<b-row class="mt-3">
						<b-col>
							<div class="position-relative pt-1">
								<FormTags
									type="text"
									placeholder="Enter"
									id="123"
									fileFormat="text"
									:suggestions="[]"
									:vmodel="formData.languages"
									@select-value="updateLanguage"
									maxFileSize="5000"
									:label="'Languages Known'"
								/>
							</div>
						</b-col>
					</b-row>
					<b-row class="mt-3">
						<b-col>
							<div class="position-relative pt-1">
								<SelectCustom
									placeholder="select"
									id="123"
									:values="values"
									:dropdown="true"
									:vmodel="formData.noticeKey"
									@select-value="updateNoticePeriod"
									:label="'Notice period'"
								/>
							</div>
						</b-col>
					</b-row>
					<b-row class="mt-3">
						<b-col>
							<div class="position-relative pt-1">
								<SelectCustom
									placeholder="select"
									id="123"
									:values="workType"
									:dropdown="true"
									:vmodel="formData.workKey"
									@select-value="updateWorkType"
									:label="'Work Type'"
								/>
							</div>
						</b-col>
					</b-row>
				</div>
			</div>
			<div class="mobjd-applied-footer w-100 px-3">
				<div class="mob-cancelBtn w-50 pr-2">
					<b-button class="w-100" @click="$router.go(-1)">Cancel</b-button>
				</div>
				<div class="mob-addBtn position-relative w-50 pl-2">
					<b-button class="w-100" @click="saveJobPreferences">{{
						showSave
					}}</b-button>
					<div class="loader-pos-pref-mob" v-if="showLoader">
						<Loader />
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { saveJobPreference, getJobPreference } from "@/utils/apiFunctions";
import EventBus from "@/utils/EventBus";
import FormTags from "@/components/InputComponents/FormTags.vue";
import Loader from "@/components/fixedcomponents/Loader.vue";
import SelectCustom from "@/components/InputComponents/SelectCustom.vue";
import InputField from "@/components/InputComponents/Input.vue";
import { mapGetters } from "vuex";
export default {
	data() {
		return {
			showLoader: false,
			showSave: "Save",
			formData: {
				currentCTC: "",
				expectedCTC: "",
				willingToRelocateTo: [], // Changed to array since using FormTags
				languages: [], // Changed to array since using FormTags
				noticePeriod: "", // Will store selected value from SelectCustom
				noticeKey: "",
				workType: [], // Will store selected value from SelectCustom
				workKey: "",
			},
			values: [
				{ label: "Immediate", key: "immediate", seq: 1 },
				{ label: "15 Days", key: "15 Days", seq: 2 },
				{ label: "30 Days", key: "30 Days", seq: 3 },
				{ label: "60 Days", key: "60 Days", seq: 4 },
				{ label: "90 Days", key: "90 Days", seq: 5 },
				{
					label: "Currently on notice period",
					key: "currently on notice period",
					seq: 6,
				},
			],
			workType: [
				{
					label: "Hybrid",
					key: "hybrid",
					seq: 1,
				},
				{
					label: "Remote",
					key: "remote",
					seq: 2,
				},
				{
					label: "From Office",
					key: "fromOffice",
					seq: 3,
				},
			],
		};
	},
	components: {
		FormTags,
		SelectCustom,
		Loader,
		InputField,
	},
	created() {
		this.getPreferences();
	},
	computed: {
		...mapGetters("userVUEX", {
			userinfo: "getUserInfo",
		}),
	},
	methods: {
		updateCurrentCTC(value) {
			this.formData.currentCTC = value;
		},
		updateExpectedCTC(value) {
			this.formData.expectedCTC = value;
		},
		updateLocation(value) {
			this.formData.willingToRelocateTo = Array.isArray(value)
				? value
				: [value];
		},
		updateLanguage(value) {
			this.formData.languages = Array.isArray(value) ? value : [value];
		},
		updateNoticePeriod(value) {
			this.formData.noticePeriod = value;
		},
		updateWorkType(value) {
			this.formData.workType = [value];
		},
		async getPreferences() {
			try {
				const emailID = this.userinfo.email;
				const res = await getJobPreference(emailID);
				if (res.status == 200) {
					const data = res.data.data;
					if (data.submitted) {
						this.showSave = "Update";
						this.showPreferences = true;
						this.formData.currentCTC =
							data.currentCTC == 0 ? "" : data.currentCTC;
						this.formData.expectedCTC =
							data.expectedCTC == 0 ? "" : data.expectedCTC;
						this.formData.willingToRelocateTo = data.willingToRelocateTo;
						this.formData.languages = data.languages;
						this.formData.noticePeriod = data.noticePeriod;
						const selectedOption = this.values.find(
							(option) => option.key === data.noticePeriod
						);
						this.formData.noticeKey = selectedOption
							? selectedOption.key
							: null;
						this.formData.workType = data.workType;
						this.formData.workKey = data.workType[0];
					}
				}
			} catch {
				console.log("error");
			}
		},
		async saveJobPreferences() {
			this.showLoader = true;
			let emailID = this.userinfo.email;
			const payload = {
				email: emailID,
				currentCTC: parseFloat(this.formData.currentCTC),
				expectedCTC: parseFloat(this.formData.expectedCTC),
				willingToRelocateTo: this.formData.willingToRelocateTo,
				languages: this.formData.languages,
				noticePeriod: this.formData.noticePeriod,
				workType: this.formData.workType,
			};
			let response = await saveJobPreference(payload);
			if (response.status == 200) {
				this.showLoader = false;
				EventBus.$emit("job-preference-updated");
				this.$router.go(-1);
				// console.log("Prefecrenced set successfully");
			}
		},
	},
};
</script>

<style>
.mob-mob-candash-modal-label {
	color: #4f4f50;
	font-family: "Montserrat", sans-serif;
	font-size: 14px;
	font-weight: 500;
}
.mobileinput {
	height: 40px !important;
	padding: 1px 0.75rem !important;
	border-radius: 8px !important;
	border: 1px solid var(--gray-300, #d0d5dd) !important;
	background: var(--base-white, var(--bg-white)) !important;
	box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05) !important;
	color: #332d2d !important;
	font-size: 14px !important;
	font-weight: 400 !important;
	font-family: "Montserrat", sans-serif;
}
.mobileinput::placeholder {
	color: #667085;
	font-size: 14px;
	font-weight: 400;
	font-family: "Montserrat", sans-serif;
}
</style>
